import ListProcesses from "@/views/organization/process/harvest_export/ListProcesses.vue";
import ShowProcess from "@/views/organization/process/harvest_export/ShowProcess.vue";
import ShowExportedBatch from "@/views/organization/process/harvest_export/ShowExportedBatch.vue";
import NewExportedBatch from "@/views/organization/process/harvest_export/NewExportedBatch.vue";
import NewHarvestedBatch from "@/views/organization/process/harvest_export/NewHarvestedBatch.vue";
import EditExportedBatch from "@/views/organization/process/harvest_export/EditExportedBatch.vue";
import EditHarvestedBatch from "@/views/organization/process/harvest_export/EditHarvestedBatch.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "org",
  role: "process",
  permission: "harvest_export"
});

export default [
  {
    path: "/org/:organization_id/process/harvest_export/list_processes",
    name: routeName(""),
    redirect: { name: routeName("list_processes") }
  },
  {
    path: "/org/:organization_id/process/harvest_export/list_processes",
    name: routeName("list_processes"),
    component: ListProcesses,
    props: true,
    meta: META
  },
  {
    path: "/org/:organization_id/process/harvest_export/show_process/:harvest_process_id",
    name: routeName("show_process"),
    component: ShowProcess,
    props: true,
    meta: META
  },
  {
    path: "/org/:organization_id/process/harvest_export/show_exported_batch/:harvest_process_id/:exported_batch_id",
    name: routeName("show_exported_batch"),
    component: ShowExportedBatch,
    props: true,
    meta: META
  },
  {
    path: "/org/:organization_id/process/harvest_export/new_exported_batch/:harvest_process_id",
    name: routeName("new_exported_batch"),
    component: NewExportedBatch,
    props: true,
    meta: META
  },
  {
    path: "/org/:organization_id/process/harvest_export/edit_exported_batch/:harvest_process_id/:exported_batch_id",
    name: routeName("edit_exported_batch"),
    component: EditExportedBatch,
    props: true,
    meta: META
  },
  {
    path: "/org/:organization_id/process/harvest_export/new_harvested_batch/:harvest_process_id/:exported_batch_id",
    name: routeName("new_harvested_batch"),
    component: NewHarvestedBatch,
    props: true,
    meta: META
  },
  {
    path: "/org/:organization_id/process/harvest_export/edit_harvested_batch/:harvest_process_id/:exported_batch_id/:harvested_batch_id",
    name: routeName("edit_harvested_batch"),
    component: EditHarvestedBatch,
    props: true,
    meta: META
  }
]
